import useDeviceSize from '@/hooks/mobile/useDeviceSize';
import StyledText, { Props } from './StyledText';

export default function LandingTitle({
  ...props
}: Props & React.PropsWithChildren) {
  // device size
  const deviceSize = useDeviceSize();

  return (
    <StyledText
      $fontSize={deviceSize === 'mobile' ? 28 : 40}
      $fontWeight="black"
      $textAlign="center"
      $wordBreak="keep-all"
      {...props}
    />
  );
}
